const API_URLS = {
  LOCAL: "http://api.gestionmajor.test:8080",
  QA: "https://api.development.majorconnect.ca",
  QA2: "https://api.qa2.majorconnect.ca",
  STAGING: "https://api.staging2.majorconnect.ca",
  DEMO: "https://api.demo.majorconnect.ca",
  PRODUCTION: "https://api.majorconnect.ca",
};

export const S3_BUCKETS = {
  LOCAL: {
    invoice: {
      bucket_name: "local.majorconnect.invoices",
      region_name: "ca-central-1",
    },
    exports: {
      bucket_name: "local.majorconnect.reports",
      region_name: "ca-central-1",
    },
    exportV2:{
      bucket_name: "local.majorconnect.exports",
      region_name: "ca-central-1",
    }
  },
  QA: {
    invoice: {
      bucket_name: "development.majorconnect.invoices",
      region_name: "ca-central-1",
    },
    exports: {
      bucket_name: "development.majorconnect.reports",
      region_name: "ca-central-1",
    },
    exportV2:{
      bucket_name: "development.majorconnect.exports",
      region_name: "ca-central-1",
    }
  },
  QA2: {
    invoice: {
      bucket_name: "qa2.majorconnect.invoices",
      region_name: "ca-central-1",
    },
    exports: {
      bucket_name: "qa2.majorconnect.reports",
      region_name: "ca-central-1",
    },
    exportV2:{
      bucket_name: "qa2.majorconnect.exports",
      region_name: "ca-central-1",
    }
  },
  STAGING: {
    invoice: {
      bucket_name: "staging.majorconnect.invoices",
      region_name: "ca-central-1",
    },
    exports: {
      bucket_name: "staging.majorconnect.reports",
      region_name: "ca-central-1",
    },
    exportV2:{
      bucket_name: "staging.majorconnect.exports",
      region_name: "ca-central-1",
    }
  },
  DEMO: {
    invoice: {
      bucket_name: "demo.majorconnect.invoices",
      region_name: "ca-central-1",
    },
    exports: {
      bucket_name: "demo.majorconnect.reports",
      region_name: "ca-central-1",
    },
    exportV2:{
      bucket_name: "demo.majorconnect.exports",
      region_name: "ca-central-1",
    }
  },
  PRODUCTION: {
    invoice: {
      bucket_name: "production.majorconnect.invoices",
      region_name: "ca-central-1",
    },
    exports: {
      bucket_name: "production.majorconnect.reports",
      region_name: "ca-central-1",
    },
    exportV2:{
      bucket_name: "production.majorconnect.exports",
      region_name: "ca-central-1",
    }
  },
};

const serviceUnavailableMessages = {
  qa: {
    en: [
      "Please note that the QA environment is available from Monday to Friday, 3:30am to 7pm ET",
    ],
    fr: [
      "Veuillez noter que l'environnement QA est disponible du lundi au vendredi de 3h30 à 19h",
    ],
  },
  qa2: {
    en: ["The service is currently unavailable"],
    fr: ["Le service est présentement indisponible"],
  },
  staging: {
    en: [
      "Please note that the Staging environment is available from Monday to Friday, 3:30am to 7pm ET",
    ],
    fr: [
      "Veuillez noter que l'environnement Staging est disponible du lundi au vendredi de 3h30 à 19h",
    ],
  },
  demo: {
    en: [
      "Please note that the Demo environment is available from Monday to Friday, 7am to 7pm ET",
    ],
    fr: [
      "Veuillez noter que l'environnement de Démo est disponible du lundi au vendredi de 7h à 19h",
    ],
  },
  production: {
    en: ["The service is currently unavailable"],
    fr: ["Le service est présentement indisponible"],
  },
  local: {
    en: ['API is unreachable at "/health", did you start the backend?'],
    fr: [
      "L'API n'est pas rejoignable à \"/health\" est-ce le backend est bien démarré ?",
    ],
  },
};

const environmentProperties = {
  [API_URLS.LOCAL]: {
    subtitle: "local",
    color: "#F87474",
    displayEnvironmentOnScreen: true,
    additionalMessages: serviceUnavailableMessages.local,
  },
  [API_URLS.QA]: {
    subtitle: "qa",
    color: "#F4C41B",
    displayEnvironmentOnScreen: true,
    additionalMessages: serviceUnavailableMessages.qa,
  },
  [API_URLS.QA2]: {
    subtitle: "qa2",
    color: "#54C43D",
    displayEnvironmentOnScreen: true,
    additionalMessages: serviceUnavailableMessages.qa,
  },
  [API_URLS.STAGING]: {
    subtitle: "staging",
    color: "#25a725",
    displayEnvironmentOnScreen: true,
    additionalMessages: serviceUnavailableMessages.staging,
  },
  [API_URLS.DEMO]: {
    subtitle: "demo",
    color: "#9f75f9",
    displayEnvironmentOnScreen: true,
    additionalMessages: serviceUnavailableMessages.demo,
  },
  [API_URLS.PRODUCTION]: {
    subtitle: undefined,
    color: undefined,
    displayEnvironmentOnScreen: false,
    additionalMessages: serviceUnavailableMessages.production,
  },
};
function matchInformationsAPIS3(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}

export const getS3Informations = () => {
  return S3_BUCKETS[matchInformationsAPIS3(API_URLS, __API_URL__)];
};

const getApiURL = () => {
  try {
    return __API_URL__;
  }
  catch(e) {
    return process.env.__API_URL__;
  }
};

export const getEnvironmentProperties = () => {
  const properties = environmentProperties[getApiURL()];
  const defaultToNoDisplay = {
    displayEnvironmentOnScreen: false,
    additionalMessages: undefined,
  };
  return properties || defaultToNoDisplay;
};



// WEBPACK FOOTER //
// ./src/components/common/environmentProperties.js